import React, { useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "utils/store";
import { strings } from "intl/fa";
import Header, { NavType } from "components/commons/header/Header";
import { NavigationActions, AppPage } from "core/navigation/navigation.slice";
import { BasicInformationStep } from "./organizationAuthSteps/BasicInformation";
import { RegistrationInformationStep } from "./organizationAuthSteps/RegistrationInformation";
import { DocumentsStep } from "./organizationAuthSteps/Documents";
import { MAX_AUTH_DUCUMENT_SIZE } from "utils/constants";

export const inputLengths = {
  nationalId: 11,
  commercialNumber: 11,
  postalCode: 10,
  fileSize: MAX_AUTH_DUCUMENT_SIZE,
};

enum OrganizationAuthSteps {
  BasicInformation = 1,
  RegistrationInformation,
  Documents,
}
export const OrganizationAuthStepsArr = [
  {
    step: 1,
    label: strings.invoicing.org_steps.basic_info,
  },
  {
    step: 2,
    label: strings.invoicing.org_steps.registration_info,
  },
  {
    step: 3,
    label: strings.invoicing.org_steps.docs,
  },
];

export function OrganizationInvoicing() {
  const dispatch = useAppDispatch();
  const returnToOrdersList = useCallback(() => {
    dispatch(NavigationActions.setAppPage(AppPage.OrdersList));
  }, []);

  const orgAuthStep = useAppSelector(
    (state) => state.navigation.organizationAuthStep
  );

  const authComponent = useMemo(() => {
    switch (orgAuthStep) {
      case OrganizationAuthSteps.BasicInformation:
        return <BasicInformationStep />;
      case OrganizationAuthSteps.RegistrationInformation:
        return <RegistrationInformationStep />;
      case OrganizationAuthSteps.Documents:
        return <DocumentsStep />;
      default:
        return <BasicInformationStep />;
    }
  }, [orgAuthStep]);

  return (
    <>
      <Header
        onClose={returnToOrdersList}
        navType={NavType.close}
        title={strings.invoicing.invoicing}
      />
      {authComponent}
    </>
  );
}
